import React from 'react';

export interface EventIconProps {
    readonly className?: string;
}

// Coffee cup icon: not in Heroicons, inlined from the design, lifted as-is
// from `dashboard/src/components/events/config.tsx`.
const CoffeeCupIcon: React.FC<EventIconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M4 8h13v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8Z" />
        <path d="M17 9h2.5a2.5 2.5 0 0 1 0 5H17" />
        <path d="M7 3v2M11 3v2" />
    </svg>
);

// A tooth: the house icon for anything clinical. Not in Heroicons.
const ToothIcon: React.FC<EventIconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M12 5.5C10.6 4.2 9.1 3.6 7.6 3.9 5.6 4.3 4.3 6.1 4.3 8.6c0 1.7.4 3.2.8 5 .3 1.4.5 2.9.7 4.4.2 1.4.8 2.1 1.7 2.1.8 0 1.3-.6 1.6-1.9l.7-3c.2-1 .6-1.5 1.2-1.5s1 .5 1.2 1.5l.7 3c.3 1.3.8 1.9 1.6 1.9.9 0 1.5-.7 1.7-2.1.2-1.5.4-3 .7-4.4.4-1.8.8-3.3.8-5 0-2.5-1.3-4.3-3.3-4.7-1.5-.3-3 .3-4.4 1.6Z" />
    </svg>
);

export { CoffeeCupIcon, ToothIcon };
